import { useMemo, useState } from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { Box } from '@mui/material';
import styles from './ApproveUsersTable.module.css'
import { useMutation, useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import { GET_APPROVER_CREATION_REQUESTS_OF_APPROVER, APPROVE_APPROVER_CREATION_REQUEST, REJECT_APPROVER_CREATION_REQUEST } from '../../services/graphql';
import keycloak from '../../keycloak';
import { getTableDensityStyles, normalizeTableDensity } from '../../config/tableDensity';

const ApproveUsersTable = () => {
  const isDarkMode = useSelector(state => state.graphql.darkMode);
  const tableDensity = normalizeTableDensity(localStorage.getItem('tableDensity'));
  const densityStyles = getTableDensityStyles(tableDensity);
  
  const [data, setData] = useState([]);

  const email = keycloak.tokenParsed?.email;

  const reloadPage = () => {
    window.location.reload();
  };


  const { loading } = useQuery(GET_APPROVER_CREATION_REQUESTS_OF_APPROVER, {
    variables: { email: email },
    onCompleted(data) {
      setData(data.getApproverCreationRequestsOfApprover.body);
    },
    onError() {
      alert('Unable to load user requests.');
    },
  });

  const [approveUser] = useMutation(APPROVE_APPROVER_CREATION_REQUEST, {
    onCompleted(data) {
      console.log("Approve User Data line 38:", data);
      if (data.approveApproverCreationRequest.status.statusCode == '200') reloadPage();
      else alert('Unable to approve user.');
    },
    onError(data) {
      console.log("Approve User Error line 43:", data);
      alert('Unable to approve user.');
    }
  });

  const [rejectUser] = useMutation(REJECT_APPROVER_CREATION_REQUEST, {
    onCompleted(data) {
      if (data.rejectApproverCreationRequest.status.statusCode == '200') reloadPage();
      else alert('Unable to reject user.');
    },
    onError() {
      alert('Unable to reject user.');
    }
  });

  const columns = useMemo(
    () => [
      {
        accessorKey: 'name',
        header: 'Name',
        size: 200,
      },
      {
        accessorKey: 'organization',
        header: 'Organization',
        size: 200,
      },
      {
        accessorKey: 'approverEmail',
        header: 'Email',
        size: 200,
      },
      {
        accessorKey: 'submittedBy',
        header: 'Submitted By',
        size: 200,
      },
      {
        accessorKey: 'tierNumber',
        header: 'Tier',
        size: 100,
      },
    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data,
    initialState: { density: densityStyles.density},
    state: { showSkeletons: loading },
    muiTableHeadRowProps: {
      sx: { backgroundColor: 'var(--theme-bg-elevated)' },
    },
    muiTableHeadCellProps: ({ table }) => ({
      sx: table.getState().density === 'compact'
        ? densityStyles.headCell
        : {},
    }),
    muiTableBodyCellProps: ({ table }) => ({
      sx: table.getState().density === 'compact'
        ? densityStyles.bodyCell
        : {},
    }),
    enableColumnResizing: true,
    enableColumnOrdering: true,
    enableRowActions: true,
    positionActionsColumn: 'last',
    displayColumnDefOptions: {
      'mrt-row-actions': {
        header: '',
        size: densityStyles.actionsColumnSize,
      },
    },
    renderRowActions: ({ row }) => { 
      // console.log("Full row data:", row.original);
      // console.log("Request ID:", row.original?.requestId);
      const requestID = row.original?.requestID;
      return (
      <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '2vw' }}>
        <button className={styles.approveButton} style={densityStyles.actionButton} onClick={() => {
          if (!requestID) {
            alert('Unable to approve user: missing requestID.');
            return;
          }
          approveUser({variables: { requestID }});
        }}>
          APPROVE
        </button>
        <button className={styles.rejectButton} style={densityStyles.actionButton} onClick={() => {
          if (!requestID) {
            alert('Unable to reject user: missing requestID.');
            return;
          }
          rejectUser({variables: { requestID }});
        }}>
          REJECT
        </button>
      </Box>
    )},
    background: {
      default:
        '#F2EFEF',
    },
    muiPaginationProps: {
      color: 'primary',
      shape: 'rounded',
      showRowsPerPage: true,
      variant: 'outlined',
    },
    paginationDisplayMode: 'pages',
    mrtTheme: {
      baseBackgroundColor: isDarkMode ? '#2a2a2a' : '#ffffff',
    },
    muiTablePaperProps: {
        sx: { backgroundColor: 'var(--theme-bg-elevated)' },
    },
    muiBottomToolbarProps: {
        sx: { backgroundColor: 'var(--theme-bg-elevated)', color: 'var(--theme-text)' },
    },
    enableTopToolbar: false,
    muiTableBodyRowProps: {
      sx: { backgroundColor: 'var(--theme-bg-elevated)', ...densityStyles.bodyRow },
    },
  });

  return <MaterialReactTable table={table} />;
};

export default ApproveUsersTable;
